/**
 * 小票：地区 BCP47、多语文案、收据窗体字体 CSS。须在 app.js 之前加载。
 */
(function (global) {
  'use strict';

  global.__OS_RECEIPT_DATA__ = {
    RECEIPT_LOCALE: {
      zh: 'zh-CN',
      de: 'de-DE',
      en: 'en-GB',
      it: 'it-IT',
      fr: 'fr-FR',
      es: 'es-ES',
      ja: 'ja-JP',
      tr: 'tr-TR',
    },
    RECEIPT_LABELS: {
      zh: {
        orderId: '订单号',
        time: '时间',
        total: '合计',
        thanks: '谢谢惠顾',
        printBtn: '打印 / 另存 PDF',
        docTitle: '小票',
        categoryZone: '分区',
        quantityLabel: '数量',
        guestCall: '称呼',
      },
      de: {
        orderId: 'Bestellnr.',
        time: 'Zeit',
        total: 'Summe',
        thanks: 'Vielen Dank',
        printBtn: 'Drucken / PDF',
        docTitle: 'Bon',
        categoryZone: 'Bereich',
        quantityLabel: 'Menge',
        guestCall: 'Name',
      },
      en: {
        orderId: 'Order no.',
        time: 'Time',
        total: 'Total',
        thanks: 'Thank you',
        printBtn: 'Print / Save PDF',
        docTitle: 'Receipt',
        categoryZone: 'Section',
        quantityLabel: 'Qty',
        guestCall: 'Name',
      },
      it: {
        orderId: 'N. ordine',
        time: 'Ora',
        total: 'Totale',
        thanks: 'Grazie',
        printBtn: 'Stampa / PDF',
        docTitle: 'Scontrino',
        categoryZone: 'Zona',
        quantityLabel: 'Qtà',
        guestCall: 'Nome',
      },
      fr: {
        orderId: 'N° commande',
        time: 'Heure',
        total: 'Total',
        thanks: 'Merci',
        printBtn: 'Imprimer / PDF',
        docTitle: 'Ticket',
        categoryZone: 'Zone',
        quantityLabel: 'Qté',
        guestCall: 'Nom',
      },
      es: {
        orderId: 'N.º pedido',
        time: 'Hora',
        total: 'Total',
        thanks: 'Gracias',
        printBtn: 'Imprimir / PDF',
        docTitle: 'Ticket',
        categoryZone: 'Zona',
        quantityLabel: 'Cant.',
        guestCall: 'Nombre',
      },
      ja: {
        orderId: '注文番号',
        time: '日時',
        total: '合計',
        thanks: 'ありがとうございました',
        printBtn: '印刷 / PDF',
        docTitle: 'レシート',
        categoryZone: '区分',
        quantityLabel: '数量',
        guestCall: 'お名前',
      },
      tr: {
        orderId: 'Sipariş no',
        time: 'Saat',
        total: 'Toplam',
        thanks: 'Teşekkürler',
        printBtn: 'Yazdır / PDF',
        docTitle: 'Fiş',
        categoryZone: 'Bölüm',
        quantityLabel: 'Adet',
        guestCall: 'İsim',
      },
    },
    RECEIPT_FONT_CSS: {
      mono:
        'body{font-family:ui-monospace,Cascadia Mono,Consolas,monospace}.h{font-size:1.05rem}.meta,.row{font-size:0.9rem}.total{font-size:1.1rem}.foot,.extra{font-size:0.8rem}',
      sans:
        'body{font-family:system-ui,-apple-system,"Segoe UI",Roboto,sans-serif}.h{font-size:1.08rem}.meta,.row{font-size:0.92rem}.total{font-size:1.12rem}.foot,.extra{font-size:0.82rem}',
      large:
        'body{font-family:ui-monospace,Cascadia Mono,Consolas,monospace}.h{font-size:1.2rem}.meta,.row{font-size:1.05rem}.total{font-size:1.25rem}.foot,.extra{font-size:0.95rem}',
    },
  };
})(typeof window !== 'undefined' ? window : globalThis);
